import {useEffect, useRef} from "react";
import {useSelector} from "react-redux";
import {useHistory} from "react-router";
import {RootStore} from "../configureStore";

type UseBackButtonHandleParams = {
    name: string;
    isBackButtonRef?: React.MutableRefObject<boolean>;
    preventDefaultBack: boolean;
    closeHandle?: () => void;
    isActive: boolean;
    disableBack: boolean;
    appendHash?: boolean;
};

const useBackButtonHandle = ({
    name,
    isBackButtonRef,
    preventDefaultBack,
    closeHandle,
    isActive,
    disableBack,
    appendHash = true,
}: UseBackButtonHandleParams): void => {
    const history = useHistory();
    const currentlyActivePopUps = useSelector((state: RootStore) => state.layout.popUpActive);
    const currentlyActivePopUpsRef = useRef(currentlyActivePopUps);
    currentlyActivePopUpsRef.current = currentlyActivePopUps;

    useEffect(() => {
        const handleBack = (event: PopStateEvent) => {
            const state = event.state as {state: {popup: string} | null} | undefined;
            const length = currentlyActivePopUpsRef.current.length;
            const currentlyActive =
                name && length > 0 ? currentlyActivePopUpsRef.current[length - 1] === name : false;
            isBackButtonRef ? (isBackButtonRef.current = false) : undefined;
            if (state?.state?.popup !== name && currentlyActive) {
                if (preventDefaultBack) {
                    // Not setting isBackButtonRef.current as PopUp should not
                    // close this case
                    history.push(
                        `${window.location.pathname}${window.location.search}${
                            appendHash ? "#popupOpen" : ""
                        }`,
                        {popup: name},
                    );

                    closeHandle && closeHandle();
                } else {
                    isBackButtonRef ? (isBackButtonRef.current = true) : undefined;

                    closeHandle && closeHandle();
                }
            }
        };
        if (isActive) {
            if (preventDefaultBack || !disableBack) {
                window.addEventListener("popstate", handleBack);
            }
        }
        return () => {
            if (isActive) {
                if (preventDefaultBack || !disableBack) {
                    window.removeEventListener("popstate", handleBack);
                }
            }
        };
    }, [
        closeHandle,
        disableBack,
        preventDefaultBack,
        isActive,
        history,
        name,
        isBackButtonRef,
        appendHash,
    ]);
};

export default useBackButtonHandle;
